import R from 'ramda';
import React, { PropTypes as pt } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { fetchLanguages, MARATHONS_SHOW_FULL_SELECTOR } from '../actions';
import { getLanguages, getShowFullSelector, getShowRegistration } from '../selectors';
import LanguageSelector from './LanguageSelector';
import FullWrapper, { Content } from './FullWrapper';
import RegistrationForm from './RegistrationForm';

import { CSSTransitionGroup } from 'react-transition-group';
import { createAction } from '../../utils/actions';


class CmpLanguageController extends React.Component {
    static propTypes = {
        fetchLanguages: pt.func.isRequired,
        showFullSelector: pt.bool.isRequired,
        showRegistration: pt.bool.isRequired,
        termsUrl: pt.string.isRequired,
        languages: pt.arrayOf(pt.shape()),
        registration: pt.shape().isRequired,
        onClose: pt.func.isRequired,
    };

    componentDidMount() {
        this.props.fetchLanguages();
    }

    render() {
        const { showFullSelector, showRegistration, termsUrl, languages, registration, onClose } = this.props;
        const fullSelector = showFullSelector && (
                <FullWrapper key="fullSelector">
                    <SelectorContent>
                        <a className="btn-close" href="#" onClick={onClose}><i className="fa fa-close fa-2x" /></a>
                        <h2 className="mb-4 text-center">Какой язык вам хотелось бы изучить?</h2>
                        <LanguageSelector />
                    </SelectorContent>
                </FullWrapper>
            );

        const registrationForm = showRegistration && <RegistrationForm
                termsUrl={termsUrl}
                key="registration"
                registration={registration}
            />;
        const preImages = languages.length && R.map(
                item => <PreImage key={item.code} src={`/static/img/bg/${item.code}.jpg`} />,
                languages,
            );

        return (
            <CSSTransitionGroup
                transitionName="example"
                transitionEnterTimeout={400}
                transitionLeaveTimeout={400}
            >
                {fullSelector}
                {registrationForm}
                {preImages}
            </CSSTransitionGroup>
        );
    }
}

const LanguageController = connect(
    state => ({
        showFullSelector: getShowFullSelector(state),
        showRegistration: getShowRegistration(state),
        languages: getLanguages(state),
    }),
    dispatch => ({
        fetchLanguages: () => dispatch(fetchLanguages()),
        onClose: () => dispatch(createAction(MARATHONS_SHOW_FULL_SELECTOR, false)),
    }),
)(CmpLanguageController);
export default LanguageController;

const PreImage = styled.img`
    display: none;
`;

const SelectorContent = styled(Content)`
    background: #2f3e9d;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    
    h2 {
        color: #fff;
    }
`;



// WEBPACK FOOTER //
// ./src/marathons/components/LanguageController.jsx